<video controls style="width: 100%" src="{{ video.url }}" autoplay="true">
</video>